import 'bootstrap/dist/css/bootstrap.min.css';
import 'mdi/css/materialdesignicons.min.css';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.css';
import 'video.js/dist/video-js.css'
import '../less/index.less';

import 'bootstrap';
import 'jquery-validation';
import 'jquery-validation/dist/localization/messages_ru';
import 'jquery-form';
import 'bootstrap-datepicker';
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.ru.min';
import 'video.js/dist/video.js'

import './common/menu';
import './common/search';
import './common/carousel';
import './common/select2';
import './common/fancybox';
import './common/special_version';

import './home/map';
import './home/slider';
import './home/form';

import './appeals/index';
import './docs/index';



// WEBPACK FOOTER //
// ./js/index.js